import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { cn } from '../../lib/utils';
import CloudUploadIcon from '../../public/icons/cloud-upload.svg';
import AddPlusIcon from '../../public/icons/add-plus.svg';
import MenuAltIcon from '../../public/icons/menu-alt.svg';
import CloseLgIcon from '../../public/icons/close-lg.svg';
import { RootState } from '../../store/reducers';

type Props = {
    handleAddCustomerModalOpen: () => void;
    handleBulkUpload: () => void;
    isMobile?: boolean;
};

const ContactFloatingAction = ({handleAddCustomerModalOpen, handleBulkUpload, isMobile = false}: Props) => {
    const router = useRouter();
    const wrapperRef = useRef<HTMLButtonElement | null>(null);
  const { isAdmin, isSuperAdmin, isDataAdmin, user } = useSelector(
    (state: RootState) => state.common,
  );

  const [isFloatingActionBtnOpen, setIsFloatingActionBtnOpen] = useState(false);

  const handleOpenFloatingActionBtn = () => {
    setIsFloatingActionBtnOpen(prev => !prev);
  };

   useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setIsFloatingActionBtnOpen(false);
      }
    };

    if (isFloatingActionBtnOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isFloatingActionBtnOpen]);

  useEffect(() => {
    const handleRouteChange = () => {
      setIsFloatingActionBtnOpen(false);
    };

    router.events.on('routeChangeStart', handleRouteChange);

    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router.events]);

  return (
    <button
    ref={wrapperRef}
      type="button"
      onClick={handleOpenFloatingActionBtn}
      className={cn(
        'flex md:hidden lg:flex w-[50px] h-[50px] rounded-full bg-secondary items-center justify-center relative'
      )}
    >
      <div
        className={cn(
          'absolute -top-[86px] right-0 w-[186px] bg-white border border-[#EDEDED] shadow-[rgba(0,0,0,0.05)_-6px_0px_15px_0px] py-2 rounded-lg',
          { hidden: !isFloatingActionBtnOpen },
        )}
      >
        <button
          type="button"
          className="w-full flex gap-3 items-center px-3 py-2 hover:bg-app-background-1"
          onClick={handleAddCustomerModalOpen}
        >
          <AddPlusIcon className="w-fit h-4 text-transparent fill-white" />
          <p className={cn({'text-xs': isMobile, "text-sm": !isMobile})}>Add new contact</p>
        </button>
        {((isAdmin && !isDataAdmin) || isSuperAdmin) &&
          user?.organisation?.feature_flags?.enable_multi_upload && (
            <button
              type="button"
              className="w-full flex gap-3 items-center px-3 py-2 hover:bg-app-background-1"
              onClick={handleBulkUpload}
            >
              <CloudUploadIcon className="w-fit h-4 text-transparent fill-white" />
              <p className={cn({'text-xs': isMobile, "text-sm": !isMobile})}>Bulk upload contact</p>
            </button>
          )}
      </div>
      {isFloatingActionBtnOpen ? (
        <CloseLgIcon className="w-6 h-6 text-white" />
      ) : (
        <MenuAltIcon className="w-6 h-6 text-white" />
      )}
    </button>
  );
};

export default ContactFloatingAction;
